  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a [routerLink]="['/dashboard']" routerLinkActive="active" class="nav-link">Home</a>
      </li>
      <li class="nav-item d-none d-sm-inline-block"><a [routerLink]="['/dashboard']" routerLinkActive="active" class="nav-link">{{this.Bank_name}}</a></li>
    </ul>


    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      
    
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-user"></i>
      
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
         
          <div class="dropdown-divider"></div>
          <a [routerLink]="['/users/UserEdit/'+this.emp_id]" class="dropdown-item">
            <i class="fas fa-user"></i> 
            Manage profile
          </a>
          <p  (click)="this.logoutbtn()" class="dropdown-item">
            <i class="fas fa-angle-right"></i> 
            Logout
          </p>
      
        </div>
      </li>
    </ul>
  </nav>

  <!-- /.navbar -->
